import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import compensationIcon from '../../img/compensation-icon.svg';
import learnIcon from '../../img/learn-icon.svg';
import graduatesIcon from '../../img/graduates-icon.svg';
import locationIcon from '../../img/location-icon.svg';
import './Careers.css';

class Careers extends Component {
  render() {
    return (
      <div className="careers">
        <Grid fluid >
          <Fade>
            <Row className="about-company">
              <Col md={12}>
                <h1 className="page-title"> Careers </h1>
              </Col>
              <Col md={8} className="header">
                <h3>
                  We are hiring!
                </h3>
                <p>
                  Check out our open roles below or if you don’t see anything that’s quite
                right for you, email us your CV anyway to <a href="mailto:info@distilledID.com">info@distilledID.com</a> anyway.
                                      For the right person we’ll get in touch if something comes up.
                </p>
                <p>
                  At Distilled ID we are our people and we value talent and commitment.
                  We’re carving out a new space in some old industries and that requires
                  both creativity and resilience. We love what we do here and we think you
                  will too!
                </p>
              </Col>
              <Col md={2} mdOffset={1} className="positions-container">
                <h5>Open positions</h5>
                <div className="positions">
                  <Link to="/careers/seniorengineer" className="link"> Senior Engineer </Link> <br />
                  <Link to="/careers/businessanalyst" className="link"> Business Analyst </Link>

                </div>
              </Col>
            </Row>
          </Fade>
          <Row>
            <div className="our-team">
              <Fade delay={300}><div className="featured img-1" /></Fade>
              <Fade delay={100}><div className="featured img-2" /></Fade>
              <Fade delay={500}><div className="featured img-3" /></Fade>
              <Fade delay={500}><div className="featured img-4" /></Fade>
              <Fade delay={300}><div className="featured img-5" /></Fade>
              <Fade delay={100}><div className="featured img-6" /></Fade>
            </div>
          </Row>
          <Row className="join-us">
            <Fade>
              <Col md={12}>
                <h1>
                  Join our team and help us deliver meaningful change
                </h1>
              </Col>
            </Fade>
          </Row>
          <Row className="benefits">
            <Fade>
              <Col md={4} mdOffset={2} className="benefit">
                <img src={compensationIcon} alt="compensation" />
                <h1>Compensation</h1>
                <h2>
                  We offer competitive salaries and a solid company pension package.
                  We’re a rapidly expanding start-up which comes with its own set of
                  reward opportunities.
                </h2>
              </Col>
            </Fade>
            <Fade>
              <Col md={4} className="benefit">
                <img src={learnIcon} alt="learn" />
                <h1>learn and grow</h1>
                <h2>
                  Join one of the most exciting SaaS companies in Edinburgh, have real
                  impact on the product and take the chance develop your skills.
                </h2>
              </Col>
            </Fade>
          </Row>
          <Row className="benefits">
            <Fade>
              <Col md={4} mdOffset={2} className="benefit">
                <img src={graduatesIcon} alt="graduates" />
                <h1>Graduates</h1>
                <h2>
                  We love graduates at Distilled ID and we are committed to teaching them
                  how to succeed in a fast paced technology environment.
                </h2>
              </Col>
            </Fade>
            <Fade>
              <Col md={4} className="benefit">
                <img src={locationIcon} alt="location" />
                <h1>Location</h1>
                <h2>
                  Distilled ID is run from some beautiful offices in the heart of Edinburgh.
                  Walking distance from the city center and transport links.
                </h2>
              </Col>
            </Fade>
          </Row>
        </Grid>
      </div >
    );
  }
}

export default Careers;



// WEBPACK FOOTER //
// ./src/components/common/Careers.js